const context = require.context('./i18n', true, /\.(js)$/);
const i18n = {};

context.keys().forEach((filename) => {
  const code = filename.match(/^\.\/(.*)\.js$/)[1];
  if (!code) {
    throw new Error(`Could not build code for language ${filename}`);
  } else {
    i18n[code] = context(filename).default;
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js